import './info-number.scss';

import CountUp from 'countup.js';

class InfoNumber {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-infonumber',
            separatorAttr: 'data-infonumber-separator',
            numberAttr: 'count'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$infoNumber = $element;
        this.$number = this.$infoNumber.querySelector(`[${this.settings.initAttr}="${this.settings.numberAttr}"]`);

        this.eventScroller = window.eventScroller;
        this.elementOnScreen = false;
        this.isInitialized = false;

        this.countUpOptions = {
            useEasing: true,
            useGrouping: true,
            separator: ''
        };

        this.initialize();
    }

    initialize () {
        this.checkElementInview();
        this.eventScroller.customFunctions.push(() => {
            if (this.isInitialized === false) {
                this.checkElementInview();
            }
        });
    }

    checkElementInview () {
        this.elementOnScreen = this.eventScroller.onScreen(this.$infoNumber, 0, true);

        if (this.elementOnScreen === true) {
            this.$number.innerText = 0;
            let targetValue = this.$number.getAttribute('rel');

            const startValue = 0;

            let decimals = 0;
            if (targetValue.indexOf('.') >= 0) {
                decimals = targetValue.split('.')[1].length;

                const decimalOption = {
                    decimal: ','
                };

                this.countUpOptions = Object.assign({}, this.countUpOptions, decimalOption);
            }

            targetValue = parseFloat(targetValue);

            if (this.$number.hasAttribute(this.settings.separatorAttr)) {
                const separatorOption = {
                    separator: '.'
                };

                this.countUpOptions = Object.assign({}, this.countUpOptions, separatorOption);
            }

            const counter = new CountUp(this.$number, startValue, targetValue, decimals, 2, this.countUpOptions);
            if (!counter.error) {
                window.setTimeout(() => {
                    counter.start();
                }, 100);
            } else {
                console.error(counter.error);
            }

            this.isInitialized = true;
        }
    }

    resetToZero () {

    }
}

export { InfoNumber };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$infoNumber = $context.querySelectorAll('[data-infonumber="root"]');
        for (let i = 0; i < $$infoNumber.length; i++) {
            const $infoNumber = $$infoNumber[i];

            const infoNumberAPI = new InfoNumber($infoNumber);
            $infoNumber.API = infoNumberAPI;
        }
    }
});
